import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'

export const MainLayoutContainer = styled.div<{portalType?: string}>`
  width: 100%;
  min-height: 100%;
  display: grid;
  grid-template-columns: ${props => props.portalType === 'customer' ? '260px' : '230px'} auto;
  background: #F9F5F2;

  aside {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;

    header {
      margin: 44px auto 54px;
      img {
        width: 137px;
        height: 42px;
      }
    }
  }

  main {
    width: 100%;
    height: 100%;
    background: #F9F5F2;
  }

  @media only screen and (max-width: 640px) {
    display: flex;
    flex-direction: column;

    aside {
      header {
        margin: 22px auto 26px;
      }
    }
  }
`

export const LinksContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 640px) {
    flex-direction: row;
    overflow-x: hidden;
  }
`

export const LinkItem = styled(Link)<{ selected?: boolean }>`
  width: 100%;
  padding: 26px 0 26px 48px;
  color: ${props => props.selected ? '#3D6666' : '#7B7C82'};
  font-weight: ${props => props.selected ? 900 : 400};
  font-size: 16px;
  line-height: 24px;
  text-decoration: none;
  margin: 0;
  ${props => props.selected && css`
    background: #F9F5F2;
  `}
  @media only screen and (max-width: 640px) {
    padding: 6px 0 6px 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`

export const MainLayoutCustomerBody = styled.div`
  width: 100%;
  height: 100%;
  padding: 82px 104px;
  display: flex;
  flex-direction: column;
  gap: 64px;
  @media only screen and (max-width: 640px) {
    padding: 40px 24px;
  }
`

export const MainLayoutCustomerBodyHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const MainLayoutCustomerTitle = styled.h1`
  font-family: 'Tiempos', sans-serif;
  font-weight: 800;
  font-size: 36px;
  line-height: 57px;
  color: #353744;
`

export const MainLayoutCustomerSubtitle = styled.h2`
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  color: #353744;
  opacity: 0.6;
`